export default "__VITE_ASSET__D4EwT91i__"